import { Flex, Text } from '@chakra-ui/react';
import ArrowRight from '@sphere/icons/components/ArrowRight';
import { Card } from '@sphere/ui';
import Link from 'next/link';
import { rem } from 'polished';
import { PropsWithChildren, ReactElement } from 'react';

type Props = {
  href: string;
  title: string;
  icon: ReactElement;
};

export const SupportCard = ({ href, title, icon, children }: PropsWithChildren<Props>) => (
  <Card
    as={Link}
    href={href}
    target="_blank"
    w="full"
    p={{ base: 'space.24', lg: 'space.40' }}
    bg="gray.2"
    transition="all .2s ease"
    borderColor="gray.4"
    role="group"
    color="primary"
    fontWeight="medium"
    fontSize={{ base: 'md', lg: 'lg' }}
    _hover={{ borderColor: 'gray.5' }}
  >
    {icon}
    <Text fontSize="2xl" mt={{ base: 'space.20', lg: 'space.48' }} mb="space.8" color="white">
      {title}
    </Text>
    {children}
    <Flex
      bg="primary"
      color="darkPurple"
      rounded="full"
      boxSize={rem(36)}
      align="center"
      justify="center"
      mt={{ base: 'space.24', lg: 'space.56' }}
    >
      <ArrowRight
        boxSize={rem(16)}
        transition="all 200ms ease-in-out"
        _groupHover={{ transform: 'translateX(4px)' }}
      />
    </Flex>
  </Card>
);
